export default "__VITE_ASSET__Bw1kD7kt__"